import { observer } from "mobx-react-lite";

type SearchIconProps = {
    showSearch: any
}

const SearchIcon = observer((props: SearchIconProps) => {
    return <i className="icon-search" onClick={() => props.showSearch()} />;
});

export default SearchIcon;